import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import {
  RegionAndProvinceField as RHFRegionAndProvinceField,
  RegionAndProvinceFieldProps as RHFRegionAndProvinceFieldProps
} from '@anytag/shared-molecules';
import { InfluencersFilterFormKeys, InfluencersFilterFormValues } from '../schemaTypes';

interface RegionAndProvinceFieldProps {
  regionFieldProps?: Omit<RHFRegionAndProvinceFieldProps<InfluencersFilterFormKeys>['regionFieldProps'], 'name'>;
  provinceFieldProps?: Omit<RHFRegionAndProvinceFieldProps<InfluencersFilterFormKeys>['provinceFieldProps'], 'name'>;
}

export const RegionAndProvinceField = ({ regionFieldProps, provinceFieldProps }: RegionAndProvinceFieldProps) => {
  const { t } = useTranslation();
  const { watch } = useFormContext<InfluencersFilterFormValues>();

  const countryIdsValue = watch('countryIds');
  const countryId = countryIdsValue.length === 1 ? countryIdsValue[0] : '';

  return (
    <RHFRegionAndProvinceField<InfluencersFilterFormKeys>
      countryId={countryId}
      regionFieldProps={{
        multiple: true,
        help: t('Tooltip.Region'),
        title: t('Selector.Region'),
        ...regionFieldProps,
        name: 'regionIds',
        disabled: regionFieldProps?.disabled || !countryId
      }}
      provinceFieldProps={{
        multiple: true,
        help: t('Tooltip.City'),
        title: t('Selector.City'),
        ...provinceFieldProps,
        name: 'provinceIds'
      }}
    />
  );
};
